module.exports = __webpack_public_path__ + "img/Haiti.68255139.svg";